import { OrderTrackingTriggerKey } from "@redotech/redo-flows-common/triggers";
import type { TriggerKey } from "@redotech/redo-model/shopper-agent/trigger-definition";
import { getTriggerById } from "@redotech/redo-model/shopper-agent/triggers";
import {
  Layout,
  RedoCheckboxCard,
} from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox-card";
import { Text } from "@redotech/redo-web/text";
import type { Dispatch, SetStateAction } from "react";
import { memo } from "react";
import { ScrollableStepLayout } from "./scrollable-step-layout";
import {
  getStaggeredContentRevealDelayMs,
  StepMotionItem,
} from "./step-motion";

const ONBOARDING_TRIGGER_KEYS: readonly TriggerKey[] = [
  OrderTrackingTriggerKey.ORDER_CREATED,
  OrderTrackingTriggerKey.ORDER_DELIVERED,
];

export interface TriggerCategoriesStepProps {
  animateItems?: boolean;
  stepNumber: number;
  selectedTriggers: TriggerKey[];
  setSelectedTriggers: Dispatch<SetStateAction<TriggerKey[]>>;
}

export const TriggerCategoriesStep = memo(function TriggerCategoriesStep({
  animateItems,
  stepNumber,
  selectedTriggers,
  setSelectedTriggers,
}: TriggerCategoriesStepProps) {
  const title = "Choose when Commerce Agent should reach out";

  return (
    <ScrollableStepLayout
      animateItems={animateItems}
      stepNumber={stepNumber}
      subtitle={
        <>
          Select which moments Commerce Agent should message customers. You can
          configure more triggers after onboarding.
        </>
      }
      title={title}
    >
      {ONBOARDING_TRIGGER_KEYS.map((triggerKey, index) => {
        const trigger = getTriggerById(triggerKey);
        const checked = selectedTriggers.includes(triggerKey);
        return (
          <StepMotionItem
            animateItems={animateItems}
            delayMs={getStaggeredContentRevealDelayMs(title, index)}
            key={triggerKey}
          >
            <RedoCheckboxCard
              checked={checked}
              inputType="checkbox"
              layout={Layout.LEFT}
              onClick={() =>
                setSelectedTriggers((current) =>
                  current.includes(triggerKey)
                    ? current.filter((value) => value !== triggerKey)
                    : [...current, triggerKey],
                )
              }
              title={trigger?.name ?? triggerKey}
            >
              {trigger?.description ? (
                <Text fontSize="xs" textColor="tertiary">
                  {trigger.description}
                </Text>
              ) : null}
            </RedoCheckboxCard>
          </StepMotionItem>
        );
      })}
    </ScrollableStepLayout>
  );
});
